/**
 * Given a JSON-serializable object, encode as a Base64 string.
 */
export function encodeJSON(options) {
    return btoa(JSON.stringify(options));
}
/**
 * Given a Base64 JSON string, decode a JavaScript object.
 */
export function decodeJSON(queryString) {
    return JSON.parse(atob(queryString));
}
//# sourceMappingURL=base64-json.js.map